'use client';

import React, { useState } from 'react';
import { Box, Fab, styled, Tooltip } from '@mui/material';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import A11yMenu from "@/app/__to_be_integrated/_____components/floating-edge-menu/components/a11y/A11yMenu";

export default function A11yButton() {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const open = Boolean(anchor);

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchor(null);
  };

  return (
    <Box>
      <Tooltip title="Barrierefreiheit" placement="right">
        <StyledFab
          color="primary"
          aria-label="Barrierefreiheit"
          size="small"
          onClick={openMenu}
          aria-controls={open ? 'a11y-header' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          sx={{ 
            display: 'flex',
            flexDirection: 'column',
            gap: '4px'
          }}
        >
          <AccessibilityNewIcon />
        </StyledFab>
      </Tooltip>

      <A11yMenu open={open} anchor={anchor} onClose={closeMenu} />
    </Box>
  );
}

const StyledFab = styled(Fab)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  border: `1px solid ${theme.palette.background.paper}`,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
}));
